export default {
  language: null,
  version: null,
  book: null,
  chapter: null,
  isSaved: false,
  sourceVersionOptions: [],
};
